import type { HttpRequest } from '@angular/common/http';
import { isBrowser } from '../utilities/platform-type';
import { ApiService } from './api';

export class MapaApi extends ApiService {
  public static readonly url = '/api';

  public static shouldIntercept(req: HttpRequest<unknown>) {
    return isBrowser() && req.url.startsWith(MapaApi.url);
  }
}
